module.exports = __webpack_public_path__ + "static/media/rinobase-nav.cc7c958e.png";